import React, { useContext, useState } from 'react'
import {UserContext} from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';
import queryString from 'query-string';

function AuthorizeComponent(props) {
  const userContext = useContext(UserContext)
  let params = queryString.parse(location.search)

  return (
      <div className="row justify-content-center">
        <div className="card mt-4 overflow-hidden" style={{width: '25rem'}}>
            <div className="card-body">
                <h2 className="card-title text-center mt-3"><b><Trans i18nKey="authorisation_required" /></b></h2>
                <p className="card-text"></p>
                <div className="mt-5">
                    <form>
                        <div className="">
                            <div className="form-floating my-3">

                            </div>
                        </div>
                        <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto">
                            <button className="btn btn-primary btn-lg" type="button" onClick={()=> userContext.authenticate(params)}>
                                <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="authorize" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  );
}

export default withTranslation()(AuthorizeComponent);
